module.exports = __webpack_public_path__ + "img/symbol_7.2cb7be3c.png";